<template>
	<transition name="app" appear>
		<div class="app">
			<hero></hero>
			<bar></bar>

			<transition name="main" appear>
				<div>
					<router-view></router-view>
				</div>
			</transition>

			<footerr></footerr>

			<subscribe v-if="subscribe"></subscribe>
		</div>
	</transition>
</template>

<script>
import {get} from "lodash";
import data from "./data";
import store from "./modules/store";

import hero from "./components/hero.vue";
import bar from "./components/bar.vue";
import footerr from "./components/footer.vue";
import subscribe from "./components/subscribe.vue";

export default {
	components: {hero, bar, footerr, subscribe},
	data() {
		return {data, store}; // make reactive
	},
	computed: {
		subscribe: (t) => t.$store.state.subscribe
	},
	created() {
		this.data.forEach((row) => {
			row.items.forEach((item) => {
				item.styles.forEach((style, i) => {
					this.$set(style, "active", i === 0 ? true : false);
					style.colors.forEach((color, i) => {
						this.$set(color, "active", i === 0 ? true : false);
						color.thumb = get(color, "img.images[1].path")
							? get(color, "img.images[1].path")
							: null;
						color.img = get(color, "img.images[0].path")
							? get(color, "img.images[0].path")
							: color.img;
					});
				});
			});
		});
	}
};
</script>

<style lang="scss" scoped>
.app-enter-active,
.app-leave-active {
	transition: opacity 0.2s ease;
}
.app-enter,
.app-leave-to {
	opacity: 0;
}

.main-enter-active,
.main-leave-active {
	transition: transform 0.4s ease, opacity 0.4s ease;
	transition-delay: 0.2s;
}
.main-enter,
.main-leave-to {
	transform: translateY(-7px);
	opacity: 0;
}
</style>
